import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { ThemeProvider } from './ThemeContext';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Login from './components/Login';
import Signup from './components/Signup';
import Profile from './components/Profile';
import AddEntry from './components/AddEntry';
import ViewEntries from './components/ViewEntries';
import Reports from './components/Reports';
import PinReset from './components/PinReset'; 
import ForgotPassword from './components/ForgotPassword';
import PlusPage from './components/PlusPage';
import AdminPage from './components/AdminPage';
import TermsPage from './components/TermsPage';
import ContactPage from './components/ContactPage';
import './App.css';

function ProtectedRoute({ children }) {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  return isLoggedIn ? children : <Navigate to="/login" replace />;
}

function SecurityCheck({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  
  useEffect(() => {
    const publicPaths = ['/login', '/signup', '/forgot-password'];
    const isPublicPath = publicPaths.includes(location.pathname);
    
    if (!isLoggedIn && !isPublicPath) {
      navigate('/login', { replace: true });
    }
  }, [location, navigate, isLoggedIn]);
  
  return children;
}

function AppContent() {
  return (
    <div className="App">
      <Navbar />
      <main className="main-content">
        <SecurityCheck>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            

            {/* Protected Routes */}
            <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/add-entry" element={<ProtectedRoute><AddEntry /></ProtectedRoute>} />
            <Route path="/view-entries" element={<ProtectedRoute><ViewEntries /></ProtectedRoute>} />
            <Route path="/edit-entry/:id" element={<ProtectedRoute><AddEntry /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
            <Route path="/reset-pin" element={<ProtectedRoute><PinReset /></ProtectedRoute>} />
            <Route path="/plus" element={<ProtectedRoute><PlusPage /></ProtectedRoute>} />

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </SecurityCheck>
      </main>
      <footer className="app-footer">
  <p>&copy; 2025 Couple Check. Built with ❤️ for stronger relationships.</p>
  <div className="footer-links">
    <span onClick={() => window.location.href = '/terms'} className="footer-link">Terms & Privacy</span>
    <span className="footer-sep">·</span>
    <span onClick={() => window.location.href = '/contact'} className="footer-link">Contact & Support</span>
  </div>
</footer>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          {/* Admin route — completely standalone, no Navbar or footer */}
          <Route path="/admin" element={<AdminPage />} />
          
          {/* All other routes go through AppContent which has Navbar + footer */}
          <Route path="/*" element={<AppContent />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;